export default __webpack_public_path__ + "static/media/mouse.15671718.png";